export var Partnership;
(function (Partnership) {
    Partnership["Dealer"] = "dealer";
    Partnership["Franchisee"] = "franchisee";
})(Partnership || (Partnership = {}));
